import { FC } from "react";

import MuiTextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";

type Props = TextFieldProps & {
  clearable?: boolean;
  onClear?: () => void;
};

const TextField: FC<Props> = ({ clearable, onClear, value, slotProps, ...rest }) => {
  const showClear = clearable && !!value;

  return (
    <MuiTextField
      value={value}
      slotProps={{
        ...slotProps,
        input: {
          ...(slotProps as { input?: object })?.input,
          endAdornment: showClear ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={onClear}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        },
      }}
      {...rest}
    />
  );
};

export default TextField;
